module.exports = __webpack_public_path__ + "img/swim-water-diving-underwater-52988.9813d3dc.jpeg";